/**
 * 错误页面 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const errorRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "",
    name: "errorPage",
    meta: {
      title: "页面不存在",
    },
    hidden: true,
    children: [
      {
        path: "/404",
        name: "404",
        component: () => import("../pages/error/404.vue"),
        meta: {
          title: "404",
        },
      },
    ],
  },
];
export default errorRoute;
